import { TIME_ZONES_ENGLISH } from 'shared-utils'

export type TimeFormat = '12hr' | '24hr'

export const getDefaultTimeFormat = (timezone: string): TimeFormat => {
	const foundGroup = TIME_ZONES_ENGLISH.find((group) =>
		group.options.some((option) => option.value === timezone),
	)

	return foundGroup?.timeFormat || '12hr'
}
